import { render, staticRenderFns } from "./changeFeeRootList.vue?vue&type=template&id=1864488a&scoped=true"
import script from "./changeFeeRootList.vue?vue&type=script&lang=js"
export * from "./changeFeeRootList.vue?vue&type=script&lang=js"
import style0 from "./changeFeeRootList.vue?vue&type=style&index=0&id=1864488a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1864488a",
  null
  
)

export default component.exports